import { render, staticRenderFns } from "./newRegisterForm.vue?vue&type=template&id=7977b3aa"
import script from "./newRegisterForm.vue?vue&type=script&lang=js"
export * from "./newRegisterForm.vue?vue&type=script&lang=js"
import style0 from "./newRegisterForm.vue?vue&type=style&index=0&id=7977b3aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports